import { Component, OnInit } from '@angular/core';
import { ReportsService } from '../reports.service'
import { GlobalFunctionsService } from '../../common/functions/global-functions.service';
import { Unit } from '../../common/models/Unit.Model';
import { SettingsService } from 'src/app/core/settings/settings.service';
import { UserLogin } from '../../common/models/UserLogin.Model';

@Component({
  selector: 'app-rep-pieces-package',
  templateUrl: './rep-pieces-package.component.html',
  styleUrls: ['./rep-pieces-package.component.scss']
})
export class RepPiecesPackageComponent implements OnInit {


  constructor(private reportService: ReportsService,
    private globalFunctionService: GlobalFunctionsService,
    private settingsService: SettingsService) { }

  downloading: boolean = false;
  user: UserLogin = null;
  currentDate: Date;
  minDate: string;
  maxDate: string;
  today: string;
  inputKeyword: string = 'UnitDescription';
  working: boolean = false;
  organizationSelected: string = '0';
  organizacionList: Unit[];
  nodesUser: Unit[] = [];
  nodesList: Unit[] = [];
  region: Unit[];
  regionSelected: string = '0';
  nodeSelected: boolean = false;
  OriginNode: Unit = new Unit();

  ngOnInit(): void {
    this.globalFunctionService.canOperate();
    this.globalFunctionService.hasFSBRPending();
    let org = 1;
    let userId = 0;
    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.user != null && this.user != undefined) {
      userId = this.user.Id
      org = this.user.Org;
    }
    this.getOrganizacion();

    this.minDate = this.globalFunctionService.getStringDate(new Date, false, 0);
    this.maxDate = this.globalFunctionService.getStringDate(new Date, false, 0);
    this.today = this.globalFunctionService.getStringDate(new Date, false, 0);
  }

  getOrganizacion(): void {
    this.working = true;

    this.reportService.getOrganizacionesByUser(this.user.Org, this.user.Id).toPromise().then((regiones: Unit[]) => {
      this.organizacionList = regiones;
      this.organizationSelected = '0';
      if (this.organizacionList != null) {
        if (this.organizacionList.length > 0) {
          this.organizationSelected = this.organizacionList[0].UnitId.toString();
        }
      }
      this.getRegion();
    }).catch(() => {
      this.globalFunctionService.messageToast(`Ocurrió un error al obtener la organización`, 'error');
    });
  }

  getNodes() {
    this.nodesUser = [];
    this.working = true;
    if (this.nodesList.length <= 0) {
      this.reportService.getCeveFactoryList().toPromise().then((resp) => {
        this.nodesList = resp;
      }).catch((err: any) => {
        console.log(err);
        this.globalFunctionService.messageToast(`Hubo un error al obtener los nodos`, 'error');
      });
    } else {
      this.clearOriginNode();
    }
    this.reportService.getUserNodesByRegion(this.user.Org, this.user.Id, this.regionSelected).toPromise().then((resp: any[]) => {
      resp.map((x) => {
        var a: Unit = new Unit();
        (a.UnitId = x.UnitId),
          (a.OrgId = x.Org),
          (a.UnitDescription = x.UnitDes),
          (a.LevelType = x.UnitLevel == 'Centro de Ventas' ? 'CEVE' : 'FAB');
        if (a.LevelType == 'FAB')
          this.nodesUser.push(a);
      });
    }).catch((err) => {
      console.log(err);
      this.globalFunctionService.messageToast(`Hubo un error al obtener la información`, 'error');
    }).finally(() => {
      this.working = false;
    });
  }


  getRegion() {
    this.working == true;
    this.reportService.getUserRegions(this.user.Org, this.user.Id, this.organizationSelected).toPromise().then((resp: Unit[]) => {
      this.region = resp;
      this.getNodes();
    })
      .catch(() => {
        this.working = false;
      });
  }



  download(): void {

    if (!this.validateFilters()) { return; }

    let user = this.settingsService.getUser();
    var nodeId = 0;
    let unitNname = 'Global';
    if (this.OriginNode.UnitId != null) {
      nodeId = this.OriginNode.UnitId;
      unitNname = this.OriginNode.UnitDescription;
    }
    console.log(nodeId);
    console.log(this.organizationSelected);
    console.log(this.regionSelected);

    this.downloading = true;
    this.reportService.getPiecesPackageReport(user.Id, nodeId, this.organizationSelected, this.regionSelected, this.minDate, this.maxDate).subscribe(resp => {
      console.log(resp);
      let blob = new Blob([resp], { type: resp.type });
      const anchor = document.createElement('a');
      anchor.download = `Reporte Piezas por Envase_${unitNname}_${this.minDate}_${this.maxDate}.xlsx`;
      anchor.href = (window.webkitURL || window.URL).createObjectURL(blob);
      anchor.click();
    }, error => {
      this.downloading = false;
      this.globalFunctionService.messageToast(`Ocurrio un error al generar el archivo, por favor vuelva a intentar.`, 'warning');
    }
      , () => {
        this.downloading = false;
      });
  }

  validateFilters(): boolean {
    console.log('inicial', this.minDate);
    console.log('final', this.maxDate);
    if (this.minDate == "") {
      this.globalFunctionService.messageToast(`Se debe especificar la fecha inicial.`, 'warning');
      return false;
    }
    if (this.maxDate == "") {
      this.globalFunctionService.messageToast(`Se debe especificar la fecha final.`, 'warning');
      return false;
    }

    if (new Date(this.maxDate) < new Date(this.minDate)) {
      this.globalFunctionService.messageToast(`La fecha inicial no puede ser mayor a la fecha final.`, 'warning');
      return false;
    }

    return true;
  }

  clearOriginNode() {
    this.OriginNode = new Unit();
    this.nodeSelected = false;
  }

  nodeSelection(origin: boolean) {
    this.nodeSelected = true;
  }

}
